/* ==========================================================================
   AMBIENT HOME — Pages collection « Luxe »
   Fichier : assets/lux-collection.js
   Filtres et tri sans rechargement, recherche dans la collection, « Voir plus »,
   choix du nombre de produits par ligne, pastilles de couleur, retour à la même
   position après une fiche produit. Aucune dépendance (ni jQuery ni autre).
   ========================================================================== */
(function () {
  'use strict';

  if (window.LuxCollection) return;

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  var designMode = !!(window.Shopify && window.Shopify.designMode);
  var instances = [];

  /* ---------- Petits outils ---------- */

  function store(kind) {
    return {
      get: function (k) {
        try { return window[kind].getItem(k); } catch (e) { return null; }
      },
      set: function (k, v) {
        try { window[kind].setItem(k, v); } catch (e) { /* stockage indisponible */ }
      },
      del: function (k) {
        try { window[kind].removeItem(k); } catch (e) { /* stockage indisponible */ }
      }
    };
  }
  var local = store('localStorage');
  var session = store('sessionStorage');

  function debounce(fn, wait) {
    var t = null;
    function run() {
      var args = arguments;
      var self = this;
      clearTimeout(t);
      t = setTimeout(function () {
        t = null;
        fn.apply(self, args);
      }, wait);
    }
    run.flush = function () {
      if (t) { clearTimeout(t); t = null; fn(); }
    };
    run.cancel = function () { clearTimeout(t); t = null; };
    return run;
  }

  function normalize(str) {
    return (str || '')
      .toString()
      .toLowerCase()
      .normalize('NFD')
      .replace(/[̀-ͯ]/g, '')
      .replace(/[^a-z0-9]+/g, ' ')
      .trim();
  }

  function escapeHtml(str) {
    return (str || '').toString().replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function rootUrl() {
    var r = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return r.charAt(r.length - 1) === '/' ? r : r + '/';
  }

  function formatMoney(cents) {
    var format = (window.theme && window.theme.moneyFormat) || '{{amount_with_comma_separator}} €';
    var re = /\{\{\s*(\w+)\s*\}\}/;
    function withDelimiters(n, precision, thousands, decimal) {
      var fixed = (n / 100).toFixed(precision);
      var parts = fixed.split('.');
      var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return whole + (parts[1] ? decimal + parts[1] : '');
    }
    var match = format.match(re);
    var value;
    switch (match ? match[1] : 'amount') {
      case 'amount_no_decimals': value = withDelimiters(cents, 0, ',', '.'); break;
      case 'amount_with_comma_separator': value = withDelimiters(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = withDelimiters(cents, 0, '.', ','); break;
      case 'amount_with_space_separator': value = withDelimiters(cents, 2, ' ', ','); break;
      case 'amount_no_decimals_with_space_separator': value = withDelimiters(cents, 0, ' ', ','); break;
      case 'amount_with_apostrophe_separator': value = withDelimiters(cents, 2, "'", '.'); break;
      default: value = withDelimiters(cents, 2, ',', '.');
    }
    var tmp = document.createElement('textarea');
    tmp.innerHTML = format.replace(re, value);
    return tmp.value;
  }

  function sizedImage(src, width) {
    if (!src) return '';
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + width;
  }

  /* Largeur de la barre de défilement (ordinateur uniquement : sur mobile elle ne prend pas de place) */
  function scrollbarWidth() {
    var w = window.innerWidth - document.documentElement.clientWidth;
    if (w <= 0 || w > 24) return 0;
    if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return 0;
    return w;
  }

  /* ---------- Hauteur de l'en-tête collant du thème ---------- */

  function headerOffset() {
    var section = document.querySelector('.shopify-section-header');
    if (!section) return 0;
    var cs = window.getComputedStyle(section);
    if (cs.position !== 'sticky' && cs.position !== 'fixed') return 0;
    /* Bas réellement visible de l'en-tête : sur ordinateur, la ligne du menu se cache sous le logo une fois collée */
    var rows = section.querySelectorAll('.header__top, .header__bottom');
    var bottom = 0;
    if (rows.length) {
      Array.prototype.forEach.call(rows, function (row) {
        var r = row.getBoundingClientRect();
        if (r.height > 0 && window.getComputedStyle(row).visibility !== 'hidden') bottom = Math.max(bottom, r.bottom);
      });
    }
    if (!bottom) bottom = section.getBoundingClientRect().bottom;
    return Math.max(0, Math.round(bottom));
  }

  var scrollTicking = false;
  function onWindowScroll() {
    if (scrollTicking) return;
    scrollTicking = true;
    window.requestAnimationFrame(function () {
      scrollTicking = false;
      var offset = headerOffset();
      instances.forEach(function (inst) { inst.setTop(offset); });
    });
  }
  window.addEventListener('scroll', onWindowScroll, { passive: true });
  window.addEventListener('resize', onWindowScroll);

  /* ---------- Verrou du défilement (panneaux ouverts) ---------- */

  var lockCount = 0;
  function lockScroll() {
    lockCount += 1;
    if (lockCount > 1) return;
    var sbw = scrollbarWidth();
    document.documentElement.classList.add('lxc-lock');
    if (sbw > 0) document.body.style.paddingRight = sbw + 'px';
  }
  function unlockScroll() {
    lockCount = Math.max(0, lockCount - 1);
    if (lockCount > 0) return;
    document.documentElement.classList.remove('lxc-lock');
    document.body.style.paddingRight = '';
  }

  /* ==========================================================================
     Une grille de collection
     ========================================================================== */

  function LuxCollection(root) {
    this.root = root;
    this.sid = root.getAttribute('data-section-id');
    this.url = root.getAttribute('data-url') || window.location.pathname;
    this.handle = root.getAttribute('data-handle') || '';
    this.title = root.getAttribute('data-title') || '';
    this.top = -1;
    this.controller = null;
    this.loadingMore = false;
    this.pagesLoaded = this.currentPage();
    this.index = null;
    this.indexPromise = null;
    this.searchActive = -1;
    this.lastFocus = null;
    this.handlers = [];

    this.applyFilters = debounce(this.applyFilters.bind(this), 320);
    this.runSearch = debounce(this.runSearch.bind(this), 110);

    this.bind();
    this.syncDensity();
    this.initNav();
    this.fitQuick();
    this.initImages(root);
    this.initReveal(root, true);
    this.initPrice();
    this.initInfinite();
    this.setTop(headerOffset());
    this.restorePosition();
    root.classList.add('lxc--ready');
  }

  LuxCollection.prototype.$ = function (sel, ctx) { return (ctx || this.root).querySelector(sel); };
  LuxCollection.prototype.$$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || this.root).querySelectorAll(sel)); };

  LuxCollection.prototype.on = function (target, type, fn, opts) {
    target.addEventListener(type, fn, opts);
    this.handlers.push([target, type, fn, opts]);
  };

  LuxCollection.prototype.destroy = function () {
    this.handlers.forEach(function (h) { h[0].removeEventListener(h[1], h[2], h[3]); });
    this.handlers = [];
    if (this.io) this.io.disconnect();
    if (this.moreIo) this.moreIo.disconnect();
    if (this.drawerOpen) this.closeDrawer(true);
    this.closeSort();
  };

  LuxCollection.prototype.currentPage = function () {
    var p = parseInt(new URLSearchParams(window.location.search).get('page'), 10);
    return p > 0 ? p : 1;
  };

  /* ---------- Barre collante ---------- */

  LuxCollection.prototype.setTop = function (offset) {
    if (offset !== this.top) {
      this.top = offset;
      this.root.style.setProperty('--lxc-top', offset + 'px');
    }
    var bar = this.$('[data-lxc-bar]');
    if (bar) {
      var stuck = bar.getBoundingClientRect().top <= offset + 1 && window.scrollY > 0;
      bar.classList.toggle('is-stuck', stuck);
    }
  };

  /* ---------- Événements ---------- */

  LuxCollection.prototype.bind = function () {
    var self = this;
    var root = this.root;

    this.on(root, 'click', function (e) {
      var t = e.target;
      var el;

      if ((el = t.closest('[data-lxc-open]'))) {
        e.preventDefault();
        self.openDrawer(el.getAttribute('data-lxc-target'), el);
        return;
      }
      if ((el = t.closest('[data-lxc-close]'))) {
        e.preventDefault();
        self.closeDrawer();
        return;
      }
      if ((el = t.closest('a[data-lxc-link]'))) {
        if (e.metaKey || e.ctrlKey || e.shiftKey || e.button > 0) return;
        e.preventDefault();
        self.load(el.href, { push: true, scroll: !el.closest('[data-lxc-drawer]') });
        return;
      }
      if ((el = t.closest('[data-lxc-sort-toggle]'))) {
        e.preventDefault();
        self.toggleSort();
        return;
      }
      if ((el = t.closest('[data-lxc-sort]'))) {
        e.preventDefault();
        self.applySort(el.getAttribute('data-lxc-sort'));
        return;
      }
      if ((el = t.closest('[data-lxc-cols]'))) {
        self.setDensity('cols', el.getAttribute('data-lxc-cols'));
        return;
      }
      if ((el = t.closest('[data-lxc-cols-m]'))) {
        self.setDensity('colsM', el.getAttribute('data-lxc-cols-m'));
        return;
      }
      if ((el = t.closest('a[data-lxc-more]'))) {
        if (e.metaKey || e.ctrlKey || e.shiftKey || e.button > 0) return;
        e.preventDefault();
        self.loadMore(el);
        return;
      }
      if ((el = t.closest('[data-lxc-more-values]'))) {
        e.preventDefault();
        var group = el.closest('.lxc-group');
        var expanded = group.classList.toggle('is-expanded');
        el.textContent = expanded ? el.getAttribute('data-less') : el.getAttribute('data-more');
        return;
      }
      if ((el = t.closest('[data-lxc-search-toggle]'))) {
        e.preventDefault();
        self.toggleMobileSearch();
        return;
      }
      if ((el = t.closest('[data-lxc-search-clear]'))) {
        e.preventDefault();
        self.clearSearch(true);
        return;
      }
      if ((el = t.closest('[data-lxc-grid] a[href]'))) {
        self.savePosition();
      }
    });

    /* Filtres : chaque changement met la grille à jour (avec un léger délai) */
    this.on(root, 'change', function (e) {
      var t = e.target;
      if (!t.closest('[data-lxc-form]')) return;
      if (t.matches('[data-lxc-range]')) return;
      if (t.matches('[data-lxc-pmin], [data-lxc-pmax]')) self.syncPriceFromFields(t.closest('[data-lxc-price]'));
      self.applyFilters();
    });

    this.on(root, 'input', function (e) {
      var t = e.target;
      if (t.matches('[data-lxc-range]')) {
        self.syncPriceFromRanges(t.closest('[data-lxc-price]'), t);
        return;
      }
      if (t.matches('[data-lxc-search]')) {
        var clear = self.$('[data-lxc-search-clear]');
        if (clear) clear.hidden = !t.value;
        self.runSearch();
      }
    });

    /* Le prix est envoyé quand on lâche le curseur */
    this.on(root, 'change', function (e) {
      if (e.target.matches('[data-lxc-range]')) self.applyFilters();
    });

    this.on(root, 'submit', function (e) {
      var form = e.target;
      if (form.matches('[data-lxc-form]')) {
        e.preventDefault();
        self.applyFilters.flush();
        self.closeDrawer();
        return;
      }
      if (form.matches('[data-lxc-search-form]')) {
        var active = self.$('.lxc-sr__item.is-active, .lxc-sr__foot.is-active');
        if (active) {
          e.preventDefault();
          self.savePosition();
          window.location.href = active.href;
        }
      }
    });

    this.on(root, 'focusin', function (e) {
      if (e.target.matches('[data-lxc-search]')) {
        self.ensureIndex();
        if (e.target.value.trim()) self.runSearch();
      }
    });

    this.on(root, 'keydown', function (e) {
      if (e.target.matches('[data-lxc-search]')) self.searchKeys(e);
    });

    /* Pastilles de couleur : aperçu de la photo de la couleur */
    this.on(root, 'mouseover', function (e) {
      var sw = e.target.closest('.lxc-swatch[data-img]');
      if (sw) self.previewSwatch(sw);
    });
    this.on(root, 'focusin', function (e) {
      var sw = e.target.closest('.lxc-swatch[data-img]');
      if (sw) self.previewSwatch(sw);
    });
    this.on(root, 'mouseout', function (e) {
      var card = e.target.closest('[data-lxc-card].is-swatching');
      if (card && !card.contains(e.relatedTarget)) self.resetSwatch(card);
    });

    /* Clic en dehors : on ferme le tri et les résultats de recherche */
    this.on(document, 'click', function (e) {
      if (!e.target.closest('[data-lxc-sort-root]') && !e.target.closest('.lxc-scrim')) self.closeSort();
      if (!e.target.closest('[data-lxc-search-root]')) self.closeSearchPanel();
    });

    this.on(document, 'keydown', function (e) {
      if (e.key !== 'Escape') return;
      if (self.drawerOpen) { self.closeDrawer(); return; }
      if (self.sortOpen) { self.closeSort(true); return; }
      self.closeSearchPanel();
    });

    this.on(window, 'popstate', function () {
      self.load(window.location.href, { push: false, scroll: false });
    });

    this.on(window, 'pageshow', function (e) {
      if (e.persisted) {
        self.closeDrawer(true);
        self.closeSort();
        self.root.classList.remove('is-loading');
      }
    });

    this.on(window, 'resize', debounce(function () {
      self.initNav();
      self.fitQuick();
    }, 150));
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(function () {
        self.fitQuick();
        self.initNav();
      });
    }
  };

  /* Raccourcis de filtres : on n'affiche que ceux qui tiennent dans la barre */
  LuxCollection.prototype.fitQuick = function () {
    var quick = this.$('.lxc-bar__quick');
    var left = this.$('.lxc-bar__left');
    if (!quick || !left) return;
    var buttons = this.$$('.lxc-bar__q', quick);
    quick.hidden = false;
    buttons.forEach(function (b) { b.hidden = false; });
    if (window.getComputedStyle(quick).display === 'none') return;
    for (var i = buttons.length - 1; i >= 0; i -= 1) {
      if (left.scrollWidth <= left.clientWidth + 1) break;
      buttons[i].hidden = true;
    }
    if (buttons.every(function (b) { return b.hidden; })) quick.hidden = true;
  };

  /* ---------- Navigation entre catégories ---------- */

  LuxCollection.prototype.initNav = function () {
    var self = this;
    var track = this.$('[data-lxc-nav]');
    var nav = this.$('[data-lxc-nav-root]');
    if (!track || !nav) return;
    var overflowing = track.scrollWidth > track.clientWidth + 2;
    var active = this.$('.lxc-nav__link.is-active', track);
    if (overflowing && active && !this.navCentered) {
      this.navCentered = true;
      var li = active.parentElement;
      var prev = track.style.scrollBehavior;
      track.style.scrollBehavior = 'auto';
      track.scrollLeft = Math.max(0, li.offsetLeft - (track.clientWidth - li.offsetWidth) / 2);
      track.style.scrollBehavior = prev;
    }
    var update = function () {
      var max = track.scrollWidth - track.clientWidth;
      nav.classList.toggle('can-prev', max > 2 && track.scrollLeft > 2);
      nav.classList.toggle('can-next', max > 2 && track.scrollLeft < max - 2);
    };
    update();
    if (!this.navBound) {
      this.navBound = true;
      this.on(track, 'scroll', function () { window.requestAnimationFrame(update); }, { passive: true });
      this.on(nav, 'click', function (e) {
        var btn = e.target.closest('[data-lxc-nav-step]');
        if (!btn) return;
        var dir = parseInt(btn.getAttribute('data-lxc-nav-step'), 10) || 1;
        track.scrollBy({ left: dir * Math.max(200, track.clientWidth * 0.6), behavior: reduceMotion.matches ? 'auto' : 'smooth' });
      });
      this.navUpdate = update;
    }
    self.navUpdate = update;
  };

  /* ---------- Produits par ligne ---------- */

  LuxCollection.prototype.syncDensity = function () {
    var grid = this.$('[data-lxc-grid]');
    var cols = local.get('lxc-cols');
    var colsM = local.get('lxc-cols-m');
    if (grid) {
      if (cols === '3' || cols === '4') grid.setAttribute('data-cols', cols);
      if (colsM === '1' || colsM === '2') grid.setAttribute('data-cols-m', colsM);
    }
    var current = grid ? grid.getAttribute('data-cols') : cols;
    var currentM = grid ? grid.getAttribute('data-cols-m') : colsM;
    this.$$('[data-lxc-cols]').forEach(function (b) {
      b.setAttribute('aria-pressed', String(b.getAttribute('data-lxc-cols') === current));
    });
    this.$$('[data-lxc-cols-m]').forEach(function (b) {
      b.setAttribute('aria-pressed', String(b.getAttribute('data-lxc-cols-m') === currentM));
    });
  };

  LuxCollection.prototype.setDensity = function (kind, value) {
    var grid = this.$('[data-lxc-grid]');
    if (kind === 'cols') local.set('lxc-cols', value);
    else local.set('lxc-cols-m', value);
    if (!grid) return;
    var apply = function () {
      if (kind === 'cols') grid.setAttribute('data-cols', value);
      else grid.setAttribute('data-cols-m', value);
    };
    if (reduceMotion.matches || !grid.animate) {
      apply();
    } else {
      grid.animate([{ opacity: 1 }, { opacity: 0 }], { duration: 180, easing: 'ease-out' }).onfinish = function () {
        apply();
        grid.animate([{ opacity: 0, transform: 'translateY(6px)' }, { opacity: 1, transform: 'none' }], { duration: 520, easing: 'cubic-bezier(.22,1,.36,1)' });
      };
    }
    this.syncDensity();
  };

  /* ---------- Images : apparition douce une fois chargées ---------- */

  LuxCollection.prototype.initImages = function (scope) {
    this.root.classList.add('lxc--fade');
    this.$$('.lxc-card__img', scope).forEach(function (img) {
      if (img.complete && img.naturalWidth > 0) {
        img.classList.add('is-loaded');
      } else {
        var done = function () { img.classList.add('is-loaded'); };
        img.addEventListener('load', done, { once: true });
        img.addEventListener('error', done, { once: true });
      }
    });
  };

  /* ---------- Apparition des cartes au défilement ---------- */

  LuxCollection.prototype.initReveal = function (scope, firstPaint) {
    if (reduceMotion.matches || designMode || !('IntersectionObserver' in window)) return;
    var self = this;
    var items = this.$$('[data-lxc-item]:not(.is-in), [data-lxc-tile]:not(.is-in)', scope);
    if (firstPaint) {
      var limit = window.innerHeight;
      items = items.filter(function (el) {
        if (el.getBoundingClientRect().top < limit) {
          el.classList.add('is-in');
          return false;
        }
        return true;
      });
    }
    this.root.classList.add('lxc--reveal');
    if (!this.io) {
      this.io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-in');
          self.io.unobserve(entry.target);
        });
      }, { rootMargin: '0px 0px -6% 0px', threshold: 0.06 });
    }
    items.forEach(function (el, i) {
      el.style.setProperty('--d', (i % 4) * 90 + 'ms');
      self.io.observe(el);
    });
  };

  /* ---------- Panneau des filtres ---------- */

  LuxCollection.prototype.openDrawer = function (targetKey, opener) {
    var drawer = this.$('[data-lxc-drawer]');
    if (!drawer) return;
    var self = this;
    this.closeSort();
    this.closeSearchPanel();
    this.lastFocus = opener || document.activeElement;
    if (!this.drawerOpen) {
      this.drawerOpen = true;
      drawer.hidden = false;
      lockScroll();
      drawer.getBoundingClientRect();
      window.requestAnimationFrame(function () { drawer.classList.add('is-open'); });
      this.$$('[data-lxc-open]').forEach(function (b) {
        if (b.hasAttribute('aria-expanded')) b.setAttribute('aria-expanded', 'true');
      });
      this.trap = function (e) { self.trapFocus(e, drawer); };
      document.addEventListener('keydown', this.trap);
    }
    var panel = this.$('.lxc-drawer__panel', drawer);
    var group = targetKey ? this.$('[data-lxc-group="' + targetKey + '"]', drawer) : null;
    if (group) {
      group.open = true;
      setTimeout(function () {
        var body = self.$('.lxc-drawer__body', drawer);
        if (body) body.scrollTo({ top: Math.max(0, group.offsetTop - 8), behavior: reduceMotion.matches ? 'auto' : 'smooth' });
        var sum = group.querySelector('summary');
        if (sum) sum.focus({ preventScroll: true });
      }, 380);
    } else if (panel) {
      setTimeout(function () { panel.focus({ preventScroll: true }); }, 60);
    }
  };

  LuxCollection.prototype.closeDrawer = function (instant) {
    var drawer = this.$('[data-lxc-drawer]');
    if (!drawer || !this.drawerOpen) return;
    this.drawerOpen = false;
    drawer.classList.remove('is-open');
    unlockScroll();
    document.removeEventListener('keydown', this.trap);
    this.$$('[data-lxc-open]').forEach(function (b) {
      if (b.hasAttribute('aria-expanded')) b.setAttribute('aria-expanded', 'false');
    });
    var hide = function () { if (!drawer.classList.contains('is-open')) drawer.hidden = true; };
    if (instant || reduceMotion.matches) hide();
    else setTimeout(hide, 760);
    if (this.lastFocus && this.lastFocus.focus && document.contains(this.lastFocus)) {
      this.lastFocus.focus({ preventScroll: true });
    }
  };

  LuxCollection.prototype.trapFocus = function (e, container) {
    if (e.key !== 'Tab') return;
    var focusables = Array.prototype.slice.call(container.querySelectorAll(
      'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), summary, [tabindex]:not([tabindex="-1"])'
    )).filter(function (el) { return el.offsetParent !== null || el.matches('.lxc-check__input, .lxc-color__input, .lxc-imgopt__input'); });
    if (!focusables.length) return;
    var first = focusables[0];
    var last = focusables[focusables.length - 1];
    if (e.shiftKey && (document.activeElement === first || !container.contains(document.activeElement))) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  };

  /* ---------- Prix : curseurs et champs ---------- */

  LuxCollection.prototype.initPrice = function () {
    var self = this;
    this.$$('[data-lxc-price]').forEach(function (box) { self.paintPrice(box); });
  };

  LuxCollection.prototype.paintPrice = function (box) {
    if (!box) return;
    var max = parseFloat(box.getAttribute('data-max')) || 1;
    var rMin = box.querySelector('[data-lxc-range="min"]');
    var rMax = box.querySelector('[data-lxc-range="max"]');
    var fill = box.querySelector('[data-lxc-price-fill]');
    if (!rMin || !rMax || !fill) return;
    var a = Math.min(parseFloat(rMin.value) || 0, parseFloat(rMax.value) || max);
    var b = Math.max(parseFloat(rMin.value) || 0, parseFloat(rMax.value) || max);
    fill.style.setProperty('--a', (a / max) * 100 + '%');
    fill.style.setProperty('--b', (b / max) * 100 + '%');
    rMin.style.zIndex = a > max * 0.9 ? 3 : 2;
  };

  LuxCollection.prototype.syncPriceFromRanges = function (box, moved) {
    if (!box) return;
    var max = parseFloat(box.getAttribute('data-max')) || 1;
    var rMin = box.querySelector('[data-lxc-range="min"]');
    var rMax = box.querySelector('[data-lxc-range="max"]');
    var fMin = box.querySelector('[data-lxc-pmin]');
    var fMax = box.querySelector('[data-lxc-pmax]');
    var lo = parseFloat(rMin.value) || 0;
    var hi = parseFloat(rMax.value) || 0;
    if (lo > hi) {
      if (moved === rMin) { rMin.value = hi; lo = hi; } else { rMax.value = lo; hi = lo; }
    }
    if (fMin) fMin.value = lo > 0 ? Math.round(lo) : '';
    if (fMax) fMax.value = hi < max ? Math.round(hi) : '';
    this.paintPrice(box);
  };

  LuxCollection.prototype.syncPriceFromFields = function (box) {
    if (!box) return;
    var max = parseFloat(box.getAttribute('data-max')) || 1;
    var rMin = box.querySelector('[data-lxc-range="min"]');
    var rMax = box.querySelector('[data-lxc-range="max"]');
    var fMin = box.querySelector('[data-lxc-pmin]');
    var fMax = box.querySelector('[data-lxc-pmax]');
    var lo = Math.max(0, Math.min(parseFloat(fMin.value) || 0, max));
    var hi = fMax.value === '' ? max : Math.max(0, Math.min(parseFloat(fMax.value) || 0, max));
    if (lo > hi) { var tmp = lo; lo = hi; hi = tmp; }
    rMin.value = lo;
    rMax.value = hi;
    fMin.value = lo > 0 ? Math.round(lo) : '';
    fMax.value = hi < max ? Math.round(hi) : '';
    this.paintPrice(box);
  };

  /* ---------- Filtres et tri : mise à jour sans recharger ---------- */

  LuxCollection.prototype.paramsFromForm = function () {
    var form = this.$('[data-lxc-form]');
    var params = new URLSearchParams();
    if (!form) {
      new URLSearchParams(window.location.search).forEach(function (v, k) {
        if (k !== 'page' && k !== 'section_id') params.append(k, v);
      });
      return params;
    }
    var defaultSort = form.getAttribute('data-default-sort');
    new FormData(form).forEach(function (value, key) {
      if (value === '' || value === null) return;
      if (key === 'sort_by' && value === defaultSort) return;
      params.append(key, value);
    });
    this.$$('[data-lxc-price]', form).forEach(function (box) {
      var max = parseFloat(box.getAttribute('data-max')) || 0;
      var fMin = box.querySelector('[data-lxc-pmin]');
      var fMax = box.querySelector('[data-lxc-pmax]');
      if (fMin && (parseFloat(fMin.value) || 0) <= 0) params.delete(fMin.name);
      if (fMax && fMax.value !== '' && parseFloat(fMax.value) >= max) params.delete(fMax.name);
    });
    return params;
  };

  LuxCollection.prototype.applyFilters = function () {
    var params = this.paramsFromForm();
    var query = params.toString();
    this.load(this.url + (query ? '?' + query : ''), { push: true, scroll: false });
  };

  LuxCollection.prototype.applySort = function (value) {
    this.closeSort();
    var input = this.$('[data-lxc-sortinput]');
    if (input) {
      input.value = value;
      this.applyFilters.cancel();
      var params = this.paramsFromForm();
      this.load(this.url + '?' + params.toString(), { push: true, scroll: true });
      return;
    }
    var p = new URLSearchParams(window.location.search);
    p.set('sort_by', value);
    p.delete('page');
    this.load(this.url + '?' + p.toString(), { push: true, scroll: true });
  };

  LuxCollection.prototype.load = function (href, opts) {
    var self = this;
    opts = opts || {};
    var target = new URL(href, window.location.origin);
    target.searchParams.delete('page');
    target.searchParams.delete('section_id');
    var fetchUrl = new URL(target.toString());
    fetchUrl.searchParams.set('section_id', this.sid);

    if (this.controller) this.controller.abort();
    var controller = ('AbortController' in window) ? new AbortController() : null;
    this.controller = controller;
    this.root.classList.add('is-loading');

    return fetch(fetchUrl.toString(), {
      credentials: 'same-origin',
      signal: controller ? controller.signal : undefined
    })
      .then(function (res) {
        if (!res.ok) throw new Error('HTTP ' + res.status);
        return res.text();
      })
      .then(function (html) {
        self.render(html);
        var clean = target.pathname + (target.search || '');
        var same = clean === window.location.pathname + window.location.search;
        if (opts.push && !same) window.history.pushState({ lxc: self.sid }, '', clean);
        else window.history.replaceState({ lxc: self.sid }, '', clean);
        self.pagesLoaded = 1;
        self.announce();
        if (opts.scroll) self.scrollToResults();
      })
      .catch(function (err) {
        if (err && err.name === 'AbortError') return;
        window.location.href = target.toString();
      })
      .then(function () {
        if (self.controller === controller) {
          self.controller = null;
          self.root.classList.remove('is-loading');
        }
      });
  };

  LuxCollection.prototype.render = function (html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = doc.querySelector('[data-lxc]');
    if (!fresh) throw new Error('Section introuvable');

    /* État du panneau : groupes ouverts, listes dépliées, défilement, élément actif */
    var drawerBody = this.$('.lxc-drawer__body');
    var scrollTop = drawerBody ? drawerBody.scrollTop : 0;
    var openState = {};
    var expanded = {};
    this.$$('[data-lxc-group]').forEach(function (g) {
      var key = g.getAttribute('data-lxc-group');
      openState[key] = g.open;
      expanded[key] = g.classList.contains('is-expanded');
    });
    var focusedId = document.activeElement && this.root.contains(document.activeElement) ? document.activeElement.id : '';

    /* Les fenêtres « Aperçu rapide » des anciennes cartes ont été déplacées dans <body> : on les retire */
    document.querySelectorAll('body > quick-add-modal[data-lxc-modal]:not([open])').forEach(function (m) {
      m.parentNode.removeChild(m);
    });

    var freshParts = {};
    fresh.querySelectorAll('[data-lxc-part]').forEach(function (el) {
      var name = el.getAttribute('data-lxc-part');
      (freshParts[name] = freshParts[name] || []).push(el);
    });
    var seen = {};
    this.$$('[data-lxc-part]').forEach(function (el) {
      var name = el.getAttribute('data-lxc-part');
      var i = seen[name] = (seen[name] || 0);
      seen[name] += 1;
      var src = freshParts[name] && freshParts[name][i];
      el.innerHTML = src ? src.innerHTML : '';
    });

    this.$$('[data-lxc-group]').forEach(function (g) {
      var key = g.getAttribute('data-lxc-group');
      if (key in openState) g.open = openState[key];
      if (expanded[key]) {
        g.classList.add('is-expanded');
        var btn = g.querySelector('[data-lxc-more-values]');
        if (btn) btn.textContent = btn.getAttribute('data-less');
      }
    });
    if (drawerBody) drawerBody.scrollTop = scrollTop;

    var results = this.$('[data-lxc-part="results"]');
    this.syncDensity();
    this.fitQuick();
    this.initImages(results);
    this.initReveal(results, false);
    this.initPrice();
    this.initInfinite();
    if (window.AmbientWishlist && typeof window.AmbientWishlist.refresh === 'function') {
      window.AmbientWishlist.refresh(this.root);
    }
    if (focusedId) {
      var again = document.getElementById(focusedId);
      if (again && this.root.contains(again)) again.focus({ preventScroll: true });
    }
  };

  LuxCollection.prototype.announce = function (text) {
    var live = this.$('[data-lxc-live]');
    var count = this.$('[data-lxc-part="count"]');
    if (live) live.textContent = text || (count ? count.textContent.trim() : '');
  };

  LuxCollection.prototype.scrollToResults = function () {
    var anchor = this.$('.lxc-meta') || this.$('[data-lxc-part="results"]');
    if (!anchor) return;
    var bar = this.$('[data-lxc-bar]');
    var offset = (this.top > 0 ? this.top : 0) + (bar ? bar.offsetHeight : 0);
    var y = anchor.getBoundingClientRect().top + window.scrollY - offset;
    if (window.scrollY > y + 4) {
      window.scrollTo({ top: Math.max(0, y), behavior: reduceMotion.matches ? 'auto' : 'smooth' });
    }
  };

  /* ---------- Tri ---------- */

  LuxCollection.prototype.toggleSort = function () {
    if (this.sortOpen) this.closeSort(true);
    else this.openSort();
  };

  LuxCollection.prototype.openSort = function () {
    var panel = this.$('[data-lxc-sort-panel]');
    var btn = this.$('[data-lxc-sort-toggle]');
    if (!panel) return;
    var self = this;
    this.closeSearchPanel();
    this.sortOpen = true;
    panel.hidden = false;
    panel.getBoundingClientRect();
    window.requestAnimationFrame(function () { panel.classList.add('is-open'); });
    if (btn) btn.setAttribute('aria-expanded', 'true');
    if (window.matchMedia('(max-width: 749px)').matches) {
      this.root.classList.add('lxc--sheet');
      var scrim = document.createElement('div');
      scrim.className = 'lxc-scrim';
      scrim.addEventListener('click', function () { self.closeSort(true); });
      panel.parentNode.insertBefore(scrim, panel);
      scrim.getBoundingClientRect();
      window.requestAnimationFrame(function () { scrim.classList.add('is-on'); });
      this.scrim = scrim;
      lockScroll();
      this.sortLocked = true;
    }
    var active = panel.querySelector('.lxc-sort__opt.is-active') || panel.querySelector('.lxc-sort__opt');
    if (active) setTimeout(function () { active.focus({ preventScroll: true }); }, 80);
  };

  LuxCollection.prototype.closeSort = function (returnFocus) {
    if (!this.sortOpen) return;
    var panel = this.$('[data-lxc-sort-panel]');
    var btn = this.$('[data-lxc-sort-toggle]');
    var self = this;
    this.sortOpen = false;
    if (btn) btn.setAttribute('aria-expanded', 'false');
    if (panel) {
      panel.classList.remove('is-open');
      setTimeout(function () { if (!self.sortOpen) panel.hidden = true; }, 520);
    }
    if (this.scrim) {
      var scrim = this.scrim;
      this.scrim = null;
      scrim.classList.remove('is-on');
      setTimeout(function () {
        if (scrim.parentNode) scrim.parentNode.removeChild(scrim);
        if (!self.sortOpen) self.root.classList.remove('lxc--sheet');
      }, 500);
    }
    if (this.sortLocked) {
      this.sortLocked = false;
      unlockScroll();
    }
    if (returnFocus && btn) btn.focus({ preventScroll: true });
  };

  /* ---------- Voir plus ---------- */

  LuxCollection.prototype.loadMore = function (link) {
    if (this.loadingMore || !link) return Promise.resolve(false);
    var self = this;
    this.loadingMore = true;
    link.classList.add('is-loading');
    var label = link.querySelector('span');
    var initial = label ? label.textContent : '';
    if (label) label.textContent = ((window.AH_I18N && window.AH_I18N.loading) || 'Chargement…');

    var url = new URL(link.href, window.location.origin);
    var page = parseInt(url.searchParams.get('page'), 10) || (this.pagesLoaded + 1);
    url.searchParams.set('section_id', this.sid);

    return fetch(url.toString(), { credentials: 'same-origin' })
      .then(function (res) {
        if (!res.ok) throw new Error('HTTP ' + res.status);
        return res.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var grid = self.$('[data-lxc-grid]');
        var incoming = doc.querySelectorAll('[data-lxc-grid] > [data-lxc-item]');
        if (!grid || !incoming.length) throw new Error('Rien à ajouter');
        var frag = document.createDocumentFragment();
        var added = [];
        Array.prototype.forEach.call(incoming, function (node) {
          var item = document.importNode(node, true);
          added.push(item);
          frag.appendChild(item);
        });
        grid.appendChild(frag);

        var currentMore = self.$('[data-lxc-more-wrap]');
        var nextMore = doc.querySelector('[data-lxc-more-wrap]');
        if (currentMore) {
          if (nextMore) {
            currentMore.parentNode.replaceChild(document.importNode(nextMore, true), currentMore);
          } else {
            currentMore.parentNode.removeChild(currentMore);
          }
        }

        self.pagesLoaded = page;
        self.initImages(grid);
        self.initReveal(grid, false);
        self.initInfinite();
        if (window.AmbientWishlist && typeof window.AmbientWishlist.refresh === 'function') {
          window.AmbientWishlist.refresh(grid);
        }
        var shown = self.$('[data-lxc-shown]');
        self.announce(((window.AH_I18N && window.AH_I18N.lc_n_shown) || '{n} créations affichées').replace('{n}', shown ? shown.textContent.trim() : added.length));
        return true;
      })
      .catch(function () {
        window.location.href = link.href;
        return false;
      })
      .then(function (ok) {
        self.loadingMore = false;
        if (document.contains(link)) {
          link.classList.remove('is-loading');
          if (label) label.textContent = initial;
        }
        return ok;
      });
  };

  LuxCollection.prototype.initInfinite = function () {
    var self = this;
    if (this.moreIo) this.moreIo.disconnect();
    var link = this.$('a[data-lxc-more][data-lxc-infinite]');
    if (!link || !('IntersectionObserver' in window)) return;
    this.moreIo = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) self.loadMore(entry.target);
      });
    }, { rootMargin: '0px 0px 700px 0px' });
    this.moreIo.observe(link);
  };

  /* ---------- Retour depuis une fiche produit : même endroit ---------- */

  LuxCollection.prototype.positionKey = function () {
    return 'lxc-pos:' + window.location.pathname + window.location.search;
  };

  LuxCollection.prototype.savePosition = function () {
    session.set(this.positionKey(), JSON.stringify({
      pages: this.pagesLoaded,
      y: Math.round(window.scrollY),
      t: Date.now()
    }));
  };

  LuxCollection.prototype.restorePosition = function () {
    var raw = session.get(this.positionKey());
    if (!raw) return;
    var nav = window.performance && performance.getEntriesByType ? performance.getEntriesByType('navigation')[0] : null;
    var isBack = nav ? nav.type === 'back_forward' : (window.performance && performance.navigation && performance.navigation.type === 2);
    if (!isBack) return;
    var state;
    try { state = JSON.parse(raw); } catch (e) { return; }
    session.del(this.positionKey());
    if (!state || Date.now() - state.t > 30 * 60 * 1000 || !(state.pages > this.pagesLoaded)) return;
    var self = this;
    var step = function () {
      var link = self.$('a[data-lxc-more]');
      if (!link || self.pagesLoaded >= state.pages) {
        window.scrollTo(0, state.y);
        return;
      }
      self.loadMore(link).then(function (ok) { if (ok) step(); });
    };
    step();
  };

  /* ---------- Pastilles de couleur ---------- */

  LuxCollection.prototype.previewSwatch = function (sw) {
    var card = sw.closest('[data-lxc-card]');
    var img = card && card.querySelector('.lxc-card__img--main');
    if (!img) return;
    if (!img.hasAttribute('data-orig-src')) {
      img.setAttribute('data-orig-src', img.getAttribute('src') || '');
      img.setAttribute('data-orig-srcset', img.getAttribute('srcset') || '');
    }
    if (sw.getAttribute('data-srcset')) img.setAttribute('srcset', sw.getAttribute('data-srcset'));
    else img.removeAttribute('srcset');
    img.setAttribute('src', sw.getAttribute('data-img'));
    img.classList.add('is-loaded');
    card.classList.add('is-swatching');
    card.querySelectorAll('.lxc-swatch').forEach(function (s) { s.classList.toggle('is-current', s === sw); });
  };

  LuxCollection.prototype.resetSwatch = function (card) {
    var img = card.querySelector('.lxc-card__img--main');
    card.classList.remove('is-swatching');
    card.querySelectorAll('.lxc-swatch.is-current').forEach(function (s) { s.classList.remove('is-current'); });
    if (!img || !img.hasAttribute('data-orig-src')) return;
    var set = img.getAttribute('data-orig-srcset');
    if (set) img.setAttribute('srcset', set);
    else img.removeAttribute('srcset');
    img.setAttribute('src', img.getAttribute('data-orig-src'));
  };

  /* ---------- Recherche dans la collection ---------- */

  LuxCollection.prototype.toggleMobileSearch = function () {
    var box = this.$('[data-lxc-search-root]');
    if (!box) return;
    var open = box.classList.toggle('is-open');
    var btn = this.$('[data-lxc-search-toggle]');
    if (btn) btn.setAttribute('aria-expanded', String(open));
    if (open) {
      this.closeSort();
      var input = this.$('[data-lxc-search]');
      if (input) setTimeout(function () { input.focus(); }, 30);
    } else {
      this.closeSearchPanel();
    }
  };

  LuxCollection.prototype.clearSearch = function (keepFocus) {
    var input = this.$('[data-lxc-search]');
    var clear = this.$('[data-lxc-search-clear]');
    if (input) {
      input.value = '';
      if (keepFocus) input.focus();
    }
    if (clear) clear.hidden = true;
    this.closeSearchPanel(true);
  };

  LuxCollection.prototype.ensureIndex = function () {
    if (this.index) return Promise.resolve(this.index);
    if (this.indexPromise) return this.indexPromise;
    var self = this;
    var key = 'lxc-idx:' + this.handle;
    var cached = session.get(key);
    if (cached) {
      try {
        var data = JSON.parse(cached);
        if (data && Date.now() - data.t < 15 * 60 * 1000 && data.items) {
          this.index = data.items;
          return Promise.resolve(this.index);
        }
      } catch (e) { /* cache illisible */ }
    }
    var items = [];
    var base = rootUrl() + 'collections/' + encodeURIComponent(this.handle) + '/products.json?limit=250&page=';
    var fetchPage = function (page) {
      return fetch(base + page, { credentials: 'same-origin' })
        .then(function (res) { return res.ok ? res.json() : { products: [] }; })
        .then(function (json) {
          var list = (json && json.products) || [];
          list.forEach(function (p) { items.push(self.slim(p)); });
          if (list.length === 250 && page < 8) return fetchPage(page + 1);
          return items;
        });
    };
    this.indexPromise = fetchPage(1)
      .then(function (list) {
        self.index = list;
        session.set(key, JSON.stringify({ t: Date.now(), items: list }));
        return list;
      })
      .catch(function () {
        self.index = [];
        return self.index;
      });
    return this.indexPromise;
  };

  LuxCollection.prototype.slim = function (p) {
    var variants = p.variants || [];
    var best = null;
    var available = false;
    variants.forEach(function (v) {
      var price = Math.round(parseFloat(v.price) * 100);
      if (v.available) available = true;
      if (!best || price < best.price) {
        best = { price: price, compare: v.compare_at_price ? Math.round(parseFloat(v.compare_at_price) * 100) : 0 };
      }
    });
    var tags = Array.isArray(p.tags) ? p.tags.join(' ') : (p.tags || '');
    var opts = (p.options || []).map(function (o) { return (o.values || []).join(' '); }).join(' ');
    var img = p.images && p.images[0] ? p.images[0].src : '';
    return {
      t: p.title,
      h: p.handle,
      ty: p.product_type || '',
      img: img,
      pr: best ? best.price : 0,
      cp: best && best.compare > best.price ? best.compare : 0,
      va: variants.length > 1 && variants.some(function (v) { return v.price !== variants[0].price; }),
      av: available,
      nt: normalize(p.title),
      n: normalize([p.title, p.product_type, p.vendor, tags, opts].join(' '))
    };
  };

  LuxCollection.prototype.match = function (item, terms) {
    var score = 0;
    for (var i = 0; i < terms.length; i += 1) {
      var t = terms[i];
      var variants = [t];
      if (t.length > 3 && /[sx]$/.test(t)) variants.push(t.slice(0, -1));
      var best = -1;
      for (var j = 0; j < variants.length; j += 1) {
        var v = variants[j];
        var pos = item.nt.indexOf(v);
        if (pos === 0) best = Math.max(best, 6);
        else if (pos > 0) best = Math.max(best, item.nt.indexOf(' ' + v) > -1 ? 4 : 2);
        else if (item.n.indexOf(v) > -1) best = Math.max(best, 1);
      }
      if (best < 0) return -1;
      score += best;
    }
    return score + (item.av ? 0.5 : 0);
  };

  LuxCollection.prototype.runSearch = function () {
    var self = this;
    var input = this.$('[data-lxc-search]');
    if (!input) return;
    var q = input.value.trim();
    if (!q) {
      this.closeSearchPanel();
      return;
    }
    var panel = this.$('[data-lxc-search-panel]');
    if (!this.index) {
      this.openSearchPanel('<span class="lxc-sr__wait" aria-hidden="true"></span>');
      this.ensureIndex().then(function () {
        if (input.value.trim() === q) self.runSearch();
      });
      return;
    }
    var terms = normalize(q).split(' ').filter(Boolean);
    var found = [];
    this.index.forEach(function (item) {
      var s = self.match(item, terms);
      if (s >= 0) found.push([s, item]);
    });
    found.sort(function (a, b) { return b[0] - a[0]; });
    var total = found.length;
    var shown = found.slice(0, 8).map(function (f) { return f[1]; });
    var searchUrl = rootUrl() + 'search?q=' + encodeURIComponent(q) + '&type=product&options%5Bprefix%5D=last';
    var currency = window.Shopify && window.Shopify.currency;
    var showPrice = !currency || !currency.rate || parseFloat(currency.rate) === 1;
    var sid = this.sid;

    var html = '';
    if (total) {
      html += '<div class="lxc-sr__head"><span>' + ((window.AH_I18N && window.AH_I18N.lc_in) || 'Dans {title}').replace('{title}', escapeHtml(this.title)) + '</span><span>' + (total > 1 ? ((window.AH_I18N && window.AH_I18N.lc_n_results) || '{n} résultats') : ((window.AH_I18N && window.AH_I18N.lc_n_result) || '{n} résultat')).replace('{n}', total) + '</span></div>';
      html += '<ul class="lxc-sr__list" role="listbox" aria-label="' + ((window.AH_I18N && window.AH_I18N.lc_products_found) || 'Produits trouvés') + '">';
      shown.forEach(function (item, i) {
        var title = escapeHtml(item.t);
        terms.forEach(function (t) {
          if (t.length < 2) return;
          var plain = normalize(item.t);
          var pos = plain.indexOf(t);
          if (pos < 0) return;
          title = escapeHtml(item.t.slice(0, pos)) + '<mark>' + escapeHtml(item.t.slice(pos, pos + t.length)) + '</mark>' + escapeHtml(item.t.slice(pos + t.length));
        });
        var price = '';
        if (showPrice && item.pr) {
          price = (item.va ? ((window.AH_I18N && window.AH_I18N.lc_from) || 'dès') + ' ' : '') + escapeHtml(formatMoney(item.pr));
          if (item.cp) price += '<s>' + escapeHtml(formatMoney(item.cp)) + '</s>';
        }
        html += '<li role="presentation"><a class="lxc-sr__item" role="option" id="LxcSr-' + sid + '-' + i + '" href="' + rootUrl() + 'products/' + encodeURIComponent(item.h) + '">' +
          (item.img ? '<img class="lxc-sr__img" src="' + escapeHtml(sizedImage(item.img, 160)) + '" alt="" loading="lazy" width="56" height="56">' : '<span class="lxc-sr__img"></span>') +
          '<span class="lxc-sr__text"><span class="lxc-sr__title">' + title + '</span>' +
          '<span class="lxc-sr__meta">' + (item.ty ? '<span class="lxc-sr__type">' + escapeHtml(item.ty) + '</span>' : '') +
          (price ? '<span class="lxc-sr__price">' + price + '</span>' : '') + '</span></span></a></li>';
      });
      html += '</ul>';
      html += '<a class="lxc-sr__foot" href="' + searchUrl + '"><span>' + ((window.AH_I18N && window.AH_I18N.lc_search_store_for) || 'Rechercher « {q} » dans toute la boutique').replace('{q}', escapeHtml(q)) + '</span><svg viewBox="0 0 16 16" fill="none" aria-hidden="true"><path d="M2 8h11M9 4l4 4-4 4" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/></svg></a>';
    } else {
      html += '<div class="lxc-sr__head"><span>' + ((window.AH_I18N && window.AH_I18N.lc_in) || 'Dans {title}').replace('{title}', escapeHtml(this.title)) + '</span></div>';
      html += '<p class="lxc-sr__empty">' + ((window.AH_I18N && window.AH_I18N.lc_no_match) || 'Aucune création ne correspond à « {q} » dans cette collection.').replace('{q}', escapeHtml(q)) + '</p>';
      html += '<a class="lxc-sr__foot" href="' + searchUrl + '"><span>' + ((window.AH_I18N && window.AH_I18N.lc_search_store) || 'Chercher dans toute la boutique') + '</span><svg viewBox="0 0 16 16" fill="none" aria-hidden="true"><path d="M2 8h11M9 4l4 4-4 4" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/></svg></a>';
    }
    this.searchActive = -1;
    this.openSearchPanel(html);
    if (panel) panel.scrollTop = 0;
  };

  LuxCollection.prototype.openSearchPanel = function (html) {
    var panel = this.$('[data-lxc-search-panel]');
    var input = this.$('[data-lxc-search]');
    if (!panel) return;
    panel.innerHTML = html;
    if (panel.hidden) {
      panel.hidden = false;
      panel.getBoundingClientRect();
      window.requestAnimationFrame(function () { panel.classList.add('is-open'); });
    }
    var room = window.innerHeight - panel.getBoundingClientRect().top - 16;
    panel.style.maxHeight = Math.max(260, Math.min(room, 600)) + 'px';
    if (input) input.setAttribute('aria-expanded', 'true');
  };

  LuxCollection.prototype.closeSearchPanel = function (keepMobileRow) {
    var panel = this.$('[data-lxc-search-panel]');
    var input = this.$('[data-lxc-search]');
    if (panel && !panel.hidden) {
      panel.classList.remove('is-open');
      panel.hidden = true;
    }
    if (input) {
      input.setAttribute('aria-expanded', 'false');
      input.removeAttribute('aria-activedescendant');
    }
    this.searchActive = -1;
    if (!keepMobileRow) {
      var box = this.$('[data-lxc-search-root]');
      if (box && box.classList.contains('is-open') && input && !input.value && document.activeElement !== input) {
        box.classList.remove('is-open');
      }
    }
  };

  LuxCollection.prototype.searchKeys = function (e) {
    var panel = this.$('[data-lxc-search-panel]');
    var input = e.target;
    if (e.key === 'Escape') {
      e.stopPropagation();
      if (panel && !panel.hidden) this.closeSearchPanel(true);
      else if (input.value) this.clearSearch(true);
      else {
        var box = this.$('[data-lxc-search-root]');
        if (box) box.classList.remove('is-open');
        input.blur();
      }
      return;
    }
    if (!panel || panel.hidden) return;
    var options = this.$$('.lxc-sr__item, .lxc-sr__foot', panel);
    if (!options.length) return;
    if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
      e.preventDefault();
      var dir = e.key === 'ArrowDown' ? 1 : -1;
      this.searchActive = (this.searchActive + dir + options.length) % options.length;
      options.forEach(function (o, i) { o.classList.toggle('is-active', i === this.searchActive); }, this);
      var current = options[this.searchActive];
      if (current.id) input.setAttribute('aria-activedescendant', current.id);
      current.scrollIntoView({ block: 'nearest' });
    }
  };

  /* ==========================================================================
     Démarrage (et rechargement dans l'éditeur de thème)
     ========================================================================== */

  function init(scope) {
    (scope || document).querySelectorAll('[data-lxc]').forEach(function (root) {
      if (root.__lxc) return;
      root.__lxc = new LuxCollection(root);
      instances.push(root.__lxc);
    });
  }

  function teardown(scope) {
    instances = instances.filter(function (inst) {
      if (scope.contains(inst.root)) {
        inst.destroy();
        inst.root.__lxc = null;
        return false;
      }
      return true;
    });
  }

  window.LuxCollection = { init: init };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:section:unload', function (e) { teardown(e.target); });
})();
